

const SinglePlayer = ({ videoId, player }) => {

    const { height, controls, mute, rel, autoPlay, modestBranding, annotation, fs } = player;
    return <div className='iframeEle'>
        <iframe id="" height={height} src={`https://www.youtube.com/embed/${videoId}?autoplay=${autoPlay ? 1 : 0}&controls=${controls ? 1 : 0}&mute=${mute ? 1 : 0}&rel=${rel ? 0 : 1}&modestbranding=${modestBranding ? 0 : 1}&iv_load_policy=${annotation ? 1 : 3}&fs=${fs ? 0 : 1}&enablejsapi=1`} frameBorder="0"></iframe>
    </div>

}
export default SinglePlayer;